export function AdminPolicy() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <h1 className="text-2xl tracking-tight">Policies</h1>
      <p className="text-[color:var(--mute)] mt-2">Allocation rules as data. Drag-build coming v3.1.</p>
    </div>
  );
}
